import { COLORS } from "./colors";

export const linkTextStyle = {
  wordBreak: "break-word",
  textDecoration: "underline",
  cursor: "pointer",
  color: COLORS.LINK_BLUE,
};

export const styles = {
  customButton: {
    backgroundColor: COLORS.OXYGEN7_PURPLE,
    '&:hover': {
      backgroundColor: 'rgba(91, 45, 130, 0.8)'
    }
  },
  flexBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
};
